import { Injectable } from '@angular/core';
import { PluginInjectorApplicationPlugin, IMenuItemPermissions, PluginInjectorService, PLUGIN_VERSIONS } from 'core-client/api';
import { AdministrationService } from './administration/administration.service'
import { WidgetControlService } from './widget-control/widget-control.service'
import { MenuItemControlService } from './menu-item-control/menu-item-control.service'
import { DashboardService } from './dashboard/dashboard.service'
import { ThemeSwitcherService } from './theme-switcher/theme-switcher.service'
import { UserProfileService } from './user-profile/user-profile.service';
import { UserPreferencesMenuService } from './user-preferences/user-preferences.service';
import { AboutMenuService } from './about/about-menu.service';
import { PwaInstallService } from './pwa-install/pwa-install.service';

@Injectable({
  providedIn: 'root'
})
export class CorePluginService {
  private plugin: PluginInjectorApplicationPlugin.IApplicationPlugin = <PluginInjectorApplicationPlugin.IApplicationPlugin>{}

  constructor(
    private readonly pluginInjectorService: PluginInjectorService,
    private readonly administrationService: AdministrationService,
		private readonly userProfileService: UserProfileService,
		private readonly userPreferencesService: UserPreferencesMenuService,
    private readonly widgetControlService: WidgetControlService,
    private readonly menuItemControlService: MenuItemControlService,
    private readonly dashboardService: DashboardService,
    private readonly themeSwitcherService: ThemeSwitcherService,
    private readonly aboutService: AboutMenuService,
    private readonly pwaInstallService: PwaInstallService,
  ) {
    this.plugin.name = 'CORE_PLUGIN';
    this.plugin.enabled = true;
    this.plugin.corePlugin = true;
    this.plugin.menuItems = [];
    this.plugin.description = 'Core plugin including administration, dashboards, and user management - always active and cannot be disabled';
    this.plugin.permissions = {
      menuitem_permissions: this.getModulePermissions()
    };
    this.plugin.version = PLUGIN_VERSIONS['core-plugin'];
  }

  async register(): Promise<void> {
    await this.initPlugin();
  }

  private async initPlugin(): Promise<void> {
    this.addHeaderNavigationMenuItems();
    this.pluginInjectorService.register(this.plugin);
  }

  private getModulePermissions(): IMenuItemPermissions {
    const adminModulePermissions = this.administrationService.getMenuItemPermissions();
	  const userProfileModulePermissions = this.userProfileService.getMenuItemPermissions();
	  const userPreferencesModulePermissions = this.userPreferencesService.getMenuItemPermissions();
    const dashboardModulePermissions = this.dashboardService.getMenuItemPermissions();
	  const widgetModulePermissions = this.widgetControlService.getMenuItemPermissions();
	  const menuItemModulePermissions = this.menuItemControlService.getMenuItemPermissions();

    return  { ...adminModulePermissions, ...userProfileModulePermissions, ...userPreferencesModulePermissions, ...dashboardModulePermissions, ...widgetModulePermissions, ...menuItemModulePermissions };
  }

  addHeaderNavigationMenuItems(): void {
    if (this.plugin?.menuItems) {
      this.plugin.menuItems = this.menuItemControlService.getNavbarMenuItem(
          this.plugin,
          this.plugin.menuItems,
          false,
          true
      );
      this.plugin.menuItems = this.widgetControlService.getNavbarMenuItem(
          this.plugin,
          this.plugin.menuItems,
          false,
          true
      );
      this.plugin.menuItems = this.dashboardService.getNavbarMenuItem(
          this.plugin,
          this.plugin.menuItems,
          false,
          true
      );
      this.plugin.menuItems = this.userProfileService.getNavbarMenuItem(
          this.plugin,
          this.plugin.menuItems,
          false,
          true
      );
      this.plugin.menuItems = this.userPreferencesService.getNavbarMenuItem(
          this.plugin,
          this.plugin.menuItems,
          false,
          true
      );
      this.plugin.menuItems = this.themeSwitcherService.getNavbarMenuItem(
          this.plugin,
          this.plugin.menuItems,
          false,
          true
      );
      this.plugin.menuItems = this.administrationService.getNavbarMenuItem(
          this.plugin,
          this.plugin.menuItems,
          true,
          false
      );
      this.plugin.menuItems = this.aboutService.getNavbarMenuItem(
          this.plugin,
          this.plugin.menuItems,
          false,
          true,
      );
      this.plugin.menuItems = this.pwaInstallService.getNavbarMenuItem(
          this.plugin,
          this.plugin.menuItems,
          false,
          true,
      );
    }
  }
}
